import React from "react";
import { Form, Input,Alert,Radio,Row,Col,InputNumber } from 'antd';
import NHFormItem from '../common/NHFormItem';
import NHFetch from "../../utils/NHFetch";
const basicUrl = "/newStudent"; //基础路径
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
class PassWordForm extends React.Component {
    static defaultProps = {
        isInit:false,
        studentCount:0,
    }
    constructor(props) {
        super(props);
        this.state = {
            initValue:1,
            studentCount:0,
        }
    }

    componentWillMount(){
        let {studentCount} = this.props;
        this.setState({studentCount:studentCount})
    }

    componentDidMount() {
        if(this.props.isInit){
        let scope = this.state.initValue;
        this.getStudentCount(scope);
        }
    }

    getStudentCount=(scope)=>{
        NHFetch(basicUrl + '/getInitPwStudentCount', 'GET',{scope:scope})
            .then(res => {
                if (res && res.data != null) {
                    this.setState({studentCount:res.data});
                } else {
                    this.setState({studentCount:0});
                }
            }).catch(err=>{
            this.setState({studentCount:0});
        });
    }

    onChange=(e)=>{
        const {setFieldsValue} = this.props.form;
        this.getStudentCount(e.target.value);
        setFieldsValue({scope:e.target.value});
    }

    render() {
        const {form} = this.props;
        const {studentCount} = this.state;
        const {getFieldDecorator} = form;
        //Alert提示布局
        const formItemLayout = {
            wrapperCol: {
                xs: { span: 24, offset: 0 },
                sm: { span: 12, offset: 6 },
                md: { span: 14, offset: 7 }
            }
        };
        const formItemLayout2 = {
            labelCol:{ span:18},
            wrapperCol:{span:5}
        };

        let message = (
            <span>
                本次操作涉及人数：
                <span style={{ fontWeight: 'bold' }}>{studentCount}</span>人
                <p style={{marginTop:'5px'}}>身份证取值最大位数为12位</p>
            </span>
        );

        let {isInit} = this.props;

        return (
            <div style={{width:'90%'}}>
                <Form layout="horizontal">
                    <FormItem {...formItemLayout}>
                        <Alert showIcon message={message} />
                    </FormItem>
                </Form>
                <Form layout="inline" style={{width:'100%',marginBottom:'14px'}}>
                    <Row gutter={24}>
                        <Col span={8} offset={2}>
                            <NHFormItem formItemLayout={formItemLayout2} id={'left'} label={"初始化规则"} form={form}>
                               <Input style={{width:'70px'}}/>
                            </NHFormItem>
                        </Col>
                        <Col span={6}>
                            <span style={{display:'inline-block',lineHeight:'39px'}}>身份证后</span>
                            <NHFormItem  formItemLayout={{wrapperCol:{span:24,offset:4}}} id={'sfzjh'} form={form} initialValue={6}>
                                <InputNumber style={{width:'55px'}} min={0} max={12}/>
                            </NHFormItem>
                            <span style={{display:'inline-block',lineHeight:'39px'}}>位</span>
                        </Col>
                        <Col span={4}>
                            <NHFormItem formItemLayout={{wrapperCol:{span:24,offset:6}}} id={'right'} form={form}>
                                <Input style={{width:'70px'}}/>
                            </NHFormItem>
                        </Col>
                    </Row>
                </Form>
                {isInit&&
                <Form>
                    <NHFormItem id={'scope'} label={'修改范围'} form={form} initialValue={this.state.initValue} onChang={(value)=>{console.log(value)}}>
                        <RadioGroup onChange={this.onChange}>
                            <Radio value={1}>无密码</Radio>
                            <Radio value={2}>有密码</Radio>
                            <Radio value={3}>全部</Radio>
                        </RadioGroup>
                    </NHFormItem>
                </Form>
                }
            </div>
        );
    }
}

const passWordForm = Form.create()(PassWordForm);

export default passWordForm;


// WEBPACK FOOTER //
// ./components/newStudentMng/passWordForm.js